var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurnM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9725 10.4825H20.985V11.985H20.9775V18.8289H19.4825V18.8214H18.7462V21H17.995H17.2437H6.74875H6.4182H5.24624V18.8214H4.5025V18.8289H3V11.2337H4.5025V6.7788H4.77295V6.75626H8.23623V3H9.73873V8.30384H8.23623V8.25125H5.9975V11.3013H4.5025V17.3264H5.24624H6.4182H6.74875V19.505H8.98748V18.7988V15.7563V14.2838H10.4224V12.0225H12.7437V15.7563H15.005V19.505H17.2437V17.3264H17.3715H18.7462H19.4825V11.985H17.9725V10.4825ZM12.7362 8.51422V7.50003V6.77883H11.2337V5.28384H14.2462V6.77883H14.2387V7.50003H15.005H15.7487H16.5V12.0226H15.005V9.00253H12.7362V8.51422Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurnM);
export default __webpack_public_path__ + "static/media/burn-m.fbab51716da34c9ee163738820c05762.svg";
export { ForwardRef as ReactComponent };